$(document).on("turbolinks:load", function(){
    booking_new();
    
})

function booking_new(){
    $("#new_adult_booking_new_form").validationEngine({
        promptPosition: "topLeft"
    });

    $("#booking-info--entry-time_select_child").change(function(){

        filter_by_reception_time__time_table__child();
    });   
    
    $("#booking-info--entry-time_select_adult").change(function(){

        filter_by_reception_time__time_table__adult();
    });  

    $('#adult_booking_create_submit').on('click',function(){
        document.getElementById('new_adult_booking_new_form').action="/adult_booking_informations";
    });

    $('#adult_booking_change_submit').on('click',function(){
        document.getElementById('new_adult_booking_new_form').action="/adult_booking_informations/change";
    });

    $('input[type="checkbox"].adult_booking_new_check__examination').on('click',function(){

        add_html_booking_information_id(this);
    });
}

function add_html_booking_information_id(obj){

    var booked_booking_information_id = $(obj).data('booked-booking-information-id');
    if (booked_booking_information_id == undefined){
        return false;
    }

    if ($(obj).prop('checked')){
        // htmlを追加する
        var html = `<input value=${booked_booking_information_id} name="adult_booking_new_form[booked_booking_information_ids][]" type="hidden" class="validate[required] adult_booking_new_booked_booking_information_id" >`
        $(obj).parent(".input_adult_booking--schedule_time_table").append(html);
    }
    else
    {
        // htmlを削除する
        $(obj).siblings(".adult_booking_new_booked_booking_information_id").remove();
    }
}

function filter_by_reception_time__time_table__child(){

    var element = document.getElementById("booking-info--entry-time_select_child");
    var value = element.value ;
    array = value.split("&");
    schedule_no = array[0]
    reception_time_from = array[1]
    reception_time_to = array[2]

    $.ajax({url:"/schedule_time_tables/of_child_is_filter_by_reception_time",
    type: "GET",
    data: {schedule_no: schedule_no, reception_time_from: reception_time_from, reception_time_to: reception_time_to},
    dataType:"json"
    })
    .done(function(data){

        // inputタグ削除    	
        time_table = $("#input_child_booking").children('.input_child_booking--schedule_time_table');
        time_table.remove();

        // 予約済み表示削除
        $("#booked_enforce_date__child").remove();

        // 新しいインプットタグ追加
        var time_table = data["time_table"]
        var html = `<input value=${time_table["schedule_time_table_no"]} 
                        class="input_child_booking--schedule_time_table" 
                        type="hidden" 
                        ${time_table["is_duplicate_booking"] ? `name="child_booking_new_form[schedule_time_table_no]" id="child_booking_new_form_schedule_time_table_no"`: `name="child_booking_information[schedule_time_table_no]" id="child_booking_information_schedule_time_table_no"`}                        
                        >`

        $("#input_child_booking").append(html);

        // 新しい予約済み表示追加
        if (data.booked_flg){

            var html2 = `<dl class='booking-info--row' id='booked_enforce_date__child'>
                            <dt>予約済み</dt>
                            <dd>
                            ${time_table["booked_enforce_date"]}実施分を予約済みです。
                            </dd>
                        </dl>`

            $(".booking-row-block").append(html2);
        }

        $('input[type="submit"]').remove();
        if(data.booking_flg){
            if (data.booked_flg){
                var html = `<input type="submit" name="commit" value="変更する" class="button button-primary" id="child_booking_change_submit"/>`
            }
            else{
                var html = `<input type="submit" name="commit" value="予約する" class="button button-primary" id="child_booking_create_submit"/>`
            }
            $('.footer-button--block').append(html);
        }
    });
}

function filter_by_reception_time__time_table__adult(){

    var element = document.getElementById("booking-info--entry-time_select_adult");
    var value = element.value ;
    array = value.split("&");
    schedule_no = array[0]
    reception_time_from = array[1]
    reception_time_to = array[2]

    $.ajax({url:"/schedule_time_tables/of_adult_is_filter_by_reception_time",
    type: "GET",
    data: {schedule_no: schedule_no, reception_time_from: reception_time_from, reception_time_to: reception_time_to},
    dataType:"json"
    })
    .done(function(data){

        // inputタグ削除    	
        time_tables = $("#input_adult_booking").children('.label-flex-booking');
        time_tables.remove();

        $.each(data.time_tables_view_model,function(index,value){
            

            var html = `<label class="label-flex-booking">
                        ${value["capacity_is_full"] || value["booked_time_table_is_target_over"]? `<div>×</div>`:`<div class="input_adult_booking--schedule_time_table"><input value=${value["schedule_time_table_no"]} 
                        class="validate[required] adult_booking_new_check__examination" 
                        type="checkbox" 
                        name="adult_booking_new_form[schedule_time_table_nos][]"
                        ${value["is_duplicate_booking"] ? `data-booked-booking-information-id=${value["booked_booking_information_id"]}` : ``}
                        ></div>`}
                        
                        <div>
                            ${value["is_duplicate_booking"] ? `<h2><span class="entry-state">予約済</span> ${value["examination_for_disp"]} </h2>
                            <p>${value["booked_enforce_date"]}実施分予約済み</p>` : `<h2><span class="entry-state error">未予約</span> ${value["examination_for_disp"]} </h2>`}
                        </div>
                        </label>`

            $("#input_adult_booking").append(html);
            
        });

        $('input[type="submit"]').remove();
        if(data.booking_flg){
            if (data.booked_flg){
                var html = `<input type="submit" name="commit" value="変更する" class="button button-primary" id="adult_booking_change_submit"/>`
                $('.footer-button--block').append(html);
            }
            else{
                var html = `<input type="submit" name="commit" value="予約する" class="button button-primary" id="adult_booking_create_submit"/>`
                $('.footer-button--block').append(html);
            }
        }

        booking_new();
    });

}
